import { useEffect } from 'react'
import { PropertiesOrderByClause, PropertiesOrderByColumn, SortOrder } from 'gql/graphql'
import ListboxDropdown, { ListboxDropdownPropTypes } from 'components/form/Home/ListboxDropdown'
import { useSort } from 'data/hooks/useSort'
import classNames from 'classnames'

export interface PropertiesSortSelectProps extends Omit<ListboxDropdownPropTypes, 'options' | 'onChange' | 'value' | 'placeholder'> {
  setOrderBy: (value: PropertiesOrderByClause[]) => void
}

const PropertiesSortSelect = ({
  setOrderBy,
  ...props
}: PropertiesSortSelectProps) => {
  const { sort, setSort, sortItems } = useSort([
    { value: 'price-l-h', label: 'Price Low - High' },
    { value: 'price-h-l', label: 'Price High - Low' },
    { value: 'bedrooms-l-h', label: 'Bedrooms Min - Max' },
    { value: 'bedrooms-h-l', label: 'Bedrooms Max - Min' },
    { value: 'most_popular', label: 'Most popular' },
  ])

  useEffect(() => {
    switch (sort?.value) {
      case 'price-l-h':
        setOrderBy([
          { column: PropertiesOrderByColumn.StayCost, order: SortOrder.Asc },
          { column: PropertiesOrderByColumn.PriceRange, order: SortOrder.Asc },
        ])
        break
      case 'price-h-l':
        setOrderBy([
          { column: PropertiesOrderByColumn.StayCost, order: SortOrder.Desc },
          { column: PropertiesOrderByColumn.PriceRange, order: SortOrder.Desc },
        ])
        break
      case 'bedrooms-l-h':
        setOrderBy([
          { column: PropertiesOrderByColumn.Bedrooms, order: SortOrder.Asc },
        ])
        break
      case 'bedrooms-h-l':
        setOrderBy([
          { column: PropertiesOrderByColumn.Bedrooms, order: SortOrder.Desc },
        ])
        break
      case 'most_popular':
        setOrderBy([
          { column: PropertiesOrderByColumn.Popularity, order: SortOrder.Desc },
        ])
        break
    }
  }, [sort])

  return (
    <ListboxDropdown
      options={sortItems}
      value={sort}
      onChange={setSort}
      placeholder="Sort by..."
      {...props}
      className={{
        wrapper: classNames('md:max-w-[210px] w-full ml-auto', props.className?.wrapper),
        ...props.className,
      }}
    />
  )
}

export default PropertiesSortSelect
